import { module } from "angular";
import { ISO_8601, utc } from "moment-timezone";

export class IsoDateInterceptorService {
    // Loose match, moment will check fully
    private static regexIso8601 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.*$/;

    // Even more loose match supporting more date/time formats probably not serialized by Newtonsoft.Json
    // private static regexIso8601 = /^(\d{4}\-?W\d{2,3}|\d{4}-)(\-?\d{1,3}(\-\d{1,2}([T ].*)?)?)?$/;
    public response = (responseData: any): any => {
        this.convertDateStringsToDates(responseData);
        return responseData;
    };

    private convertDateStringsToDates = (input: any): void => {
        if (input === null || typeof input !== "object") {
            return input;
        }
        // TODO: Rewrite for in loop
        // eslint-disable-next-line no-restricted-syntax
        for (const key in input) {
            if (!input.hasOwnProperty(key)) {
                continue;
            }

            const value = input[key];
            const match = IsoDateInterceptorService.regexIso8601.test(value);

            if (typeof value === "string" && match) {
                const dateTime = utc(value, ISO_8601);
                if (dateTime.isValid()) {
                    input[key] = dateTime;
                }
            } else if (typeof value === "object") {
                this.convertDateStringsToDates(value);
            }
        }
        return input;
    };
}

module("mmHttpInterceptors").service("isoDateInterceptorService", IsoDateInterceptorService);
